import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import store from "../store/store";
import MainPage from "../pages/MainPage";
import PersonalIdent from "../pages/PersonalIdent";
import Credentials from "../pages/MainPage/Credentials";
import Documents from "../pages/MainPage/Documents";
import Authenticate from "../pages/MainPage/AesAuthenticate";
import AuthenticateMain from "../pages/MainPage/AesAuthenticateMainPage";
import AuthenticatePhone from "../pages/MainPage/AesAuthenticatePhone";
import AuthenticateMainQES from "../pages/MainPage/QesAuthenticateMainPage";
import Identify from "../pages/MainPage/QesIdentify";
import Authenticate2faSMS from "../pages/MainPage/QesAuthenticateSMS";
import Authenticate2faPhone from "../pages/MainPage/QesAuthenticatePhone";
import Imprint from "../components/ui/other/Imprint";
import PrivacyPolicy from "../components/ui/other/PrivacyPolicy";
import Admin from "../pages/AdminPage/index";
import Login from "../pages/AdminPage/Login";
import Forgot from "../pages/AdminPage/Forgot";
import Register from "../pages/AdminPage/Register";
import WorkflowLogin from "../pages/WorkflowLogin";
import NotFound from "../pages/NotFoundPage";
import Reset from "../pages/ResetPage";
import Revoke from "../pages/RevokePage";
import RedirectNect from "../pages/MainPage/RedirectNect";
import OdisCallback from "../pages/MainPage/OdisCallback";
import RedirectNectRevoke from "../pages/RevokePage/RedirectNectRevoke";
import Quickn8 from "../pages/Quickn8";
import AuthenticateExistingSignature from "../pages/QualifiedSignature";
import AuthenticateExistingSignatureForm from "../pages/QualifiedSignature/Form";
import AuthenticateExistingSignatureDownload from "../pages/QualifiedSignature/Download";
import AuthenticateExistingSignatureUpload from "../pages/QualifiedSignature/Upload";

import {
  isAdmin,
  logged,
  loggedIPS,
  loggedNect,
  notlogged,
  revoked,
  signed,
} from "./middleware";
import WorkflowSummary from "../pages/SummaryPage";
import middlewarePipeline from "./middlewarePipeline";

Vue.use(VueRouter);
axios.defaults.baseURL = window.location.origin + "/api/";
axios.defaults.withCredentials = true;

const routes = [
  {
    path: "/",
    redirect: `/notfound`,
  },
  {
    path: "*",
    redirect: "/notfound",
  },
  {
    path: "/notfound",
    name: "NotFound",
    component: NotFound,
    meta: {
      middleware: [notlogged],
    },
  },
  {
    path: "/revoke",
    redirect: "/certManager",
  },
  {
    path: "/certManager",
    name: "RevokePage",
    component: Revoke,
  },
  {
    path: "/personalident/:secret",
    name: "PersonalIdent",
    component: PersonalIdent,
  },
  {
    path: "/nect/:signer_id",
    name: "RedirectNectRevoke",
    props: true,
    component: RedirectNectRevoke,
  },
  {
    path: "/login/:workflow_id/:signer_id",
    name: "WorkflowLogin",
    props: true,
    component: WorkflowLogin,
    meta: {
      middleware: [notlogged],
    },
  },
  {
    path: "/quickn8/:workflow_id/:signer_id",
    name: "Quickn8",
    props: true,
    component: Quickn8,
    meta: {
      middleware: [notlogged],
    },
  },
  {
    path: "/workflow/:workflow_id/:signer_id",
    name: "Workflow",
    props: true,
    component: MainPage,
    meta: {
      middleware: [logged],
    },
    children: [
      {
        path: "credentials",
        component: Credentials,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "documents",
        component: Documents,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "authenticate",
        component: AuthenticateMain,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "authenticate2fa",
        component: AuthenticateMainQES,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "identify",
        component: Identify,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "authenticate/twilio/sms",
        component: Authenticate,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "authenticate/twilio/phone",
        component: AuthenticatePhone,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "authenticate2fa/twilio/sms",
        component: Authenticate2faSMS,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "authenticate2fa/twilio/phone",
        component: Authenticate2faPhone,
        meta: {
          middleware: [logged],
        },
      },
    ],
  },
  {
    path: "/qualifiedSignature",
    name: "QualifiedSignatureIdentify",
    component: AuthenticateExistingSignature,
    props: true,
    meta: {
      middleware: [logged],
    },
    children: [
      {
        path: "form",
        component: AuthenticateExistingSignatureForm,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "download/:signer_id",
        component: AuthenticateExistingSignatureDownload,
        props: true,
        meta: {
          middleware: [logged],
        },
      },
      {
        path: "upload/:signer_id",
        component: AuthenticateExistingSignatureUpload,
        props: true,
        meta: {
          middleware: [logged],
        },
      },
    ],
  },
  {
    path: "/identified/nect/:workflow_id/:signer_id",
    name: "NectRedirect",
    props: true,
    component: RedirectNect,
    meta: {
      middleware: [loggedIPS],
    },
  },
  {
    path: "/odis/callback",
    name: "OdisCallback",
    props: true,
    component: OdisCallback,
  },
  {
    path: "/summary/",
    name: "WorkflowSummary",
    component: WorkflowSummary,
    children: [
      {
        path: "finished",
        meta: { middleware: [logged, signed] },
      },
      {
        path: "revoked",
        meta: { middleware: [logged, revoked] },
      },
    ],
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: {
      middleware: [isAdmin],
    },
  },
  {
    path: "/adminLogin",
    name: "AdminLogin",
    component: Login,
    meta: {
      middleware: [notlogged],
    },
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: Forgot,
    meta: {
      middleware: [notlogged],
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    props: true,
    meta: {
      middleware: [notlogged],
    },
    children: [
      {
        path: ":new_org",
        props: true,
        meta: { middleware: [notlogged] },
      },
    ],
  },
  {
    path: "/reset",
    component: Reset,
    name: "reset",
    meta: {
      middleware: [notlogged],
    },
  },
  {
    path: "/privacy_policy",
    name: "Privacy Policy",
    component: PrivacyPolicy,
  },
  {
    path: "/imprint",
    name: "Imprint",
    component: Imprint,
  },
];

axios.interceptors.response.use(
  (res) => {
    store.commit("ui/set_notification", { display: false });

    if (res.data.code) {
      store.commit("ui/set_notification", {
        display: true,
        code: res.data.code,
        alertClass: "success",
      });
    }
    return res;
  },
  (err) => {
    const {
      response: { status, data },
    } = err;
    store.commit("ui/set_notification", { display: false });
    if (data.code) {
      if (data.data) {
        store.commit("ui/set_notification", {
          display: true,
          code: data.data[0].msg,
          alertClass: "red",
        });
      } else {
        store.commit("ui/set_notification", {
          display: true,
          code: data.code,
          alertClass: "red",
        });
      }
    }

    if (status === 401) {
      store.dispatch("auth/logout").then(() => {
        router.push("/");
      });
      return Promise.reject(err);
    }
    if (status === 405) {
      router.push("/");
      return Promise.reject(err);
    }
    
    store.commit("set_overlay", false)
    store.commit("set_loading", false);
    return Promise.reject(err);
  }
);

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
  duplicateNavigationPolicy: "ignore",
});

router.beforeEach((to, from, next) => {
  store.commit("set_loading", true);

  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
    store,
  };
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

router.afterEach((to, from, next) => {
  store.commit("set_loading", false);
  store.commit("set_overlay", false)
});

export default router;
